export const apiGetListPackage = "Guest/GetListPackage"
export const apiGetAccount = `Guest/GetAccount`
export const apiUploadFile = "Guest/UploadFile"
export const apiRegisterIndividual = `Guest/RegisterIndividual`
export const apiRegisterOrganization = `Guest/RegisterOrganization`
export const apiSendContact = `Guest/SendContact`
export const apiGetMemberDetail = `Guest/GetMemberDetail`
export const apiGetMembershipRegisterForm = `Guest/GetMembershipRegisterForm`
